import { useEffect } from "react";
import { useFormikContext } from "formik";

interface TouchProps {
    values: any
}

const MarkAllFieldsTouched = ({values}: TouchProps) => {
  const { setTouched, initialValues } = useFormikContext();

  useEffect(() => {
    // Crear un objeto touched con todas las claves de initialValues
    const touchedFields = Object.keys(values as Record<string, any>).reduce(
      (acc, key) => ({ ...acc, [key]: true }),
      {}
    );
    setTouched(touchedFields, true); // Establece todos los campos como tocados
  }, [setTouched, initialValues, values]);

  return null;
};

export default MarkAllFieldsTouched;
